import { connect } from 'react-redux';
import { search } from '../../modules/inventory/inventoryAllocation';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';
import _ from "lodash";

const mapStateToProps = (state) => {
	const canRwInventoryAllocation = !!(_.get(state.auth.authUser, ['permissions', 'canRwInventoryAllocation'], false));

	let inventoryAllocationsByYearMonth = undefined;
	if (state.inventoryAllocation.byYearMonth) {
		inventoryAllocationsByYearMonth = state.inventoryAllocation.byYearMonth;
	}

	let inventoryAllocationWarningsByYearMonth = undefined;
	if (state.inventoryAllocation.byYearMonthWarnings) {
		inventoryAllocationWarningsByYearMonth = state.inventoryAllocation.byYearMonthWarnings;
	}

	return {
		canRwInventoryAllocation,
		inventoryAllocationsByYearMonth,
		inventoryAllocationWarningsByYearMonth,
		additionalFuelAllocationMap : state.maps.additionalFuelAllocation,
		fuelContractMap : state.maps.fuelContract,
		fuelMaintenanceCostMap : state.maps.fuelMaintenanceCost,
		terminalMap : state.maps.terminal,
		supplierMap : state.maps.supplier,
		userMap : state.maps.user,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	inventoryAllocationSearch : search,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
